<template>
        <div id='fahuo'>
              <NavTop title='发货区' :islink='true' linkurl='/index' :showarrow="false"/>
              <van-tabs v-model="active" color="#EE0A24" @change="switchTab">
                <van-tab title="我的库存"></van-tab>
                <van-tab title="发货记录"></van-tab>
             </van-tabs>
             <div class="tabcon" v-if="active==0">
                    <div class="maincon" v-if="hasstock===0">
                        <van-empty description="您还没有可用库存哦" />
                    </div>
                    <div class='maincon' v-if="hasstock>0">
                        <div class="goodsitem" v-for="item in goodslist" :key="item.id">
                            <div class="goodsitem-row">
                                <div class="goodsitem-col1"><img :src='item.headimg'/></div>
                                <div class="goodsitem-col2">
                                    <div class="goodsitem-col2-line1">{{item.name}}</div>
                                    <div class="goodsitem-col2-line2" v-if="!item.isex">库存数:{{item.stock}}</div>
                                    <div class="goodsitem-col2-line2" v-else>可兑换数:{{item.stock}}</div>
                                    <div class="goodsitem-col2-line2"></div>
                                    <div class="goodsitem-col2-line3">
                                        <div class="goodsprice" v-if="item.tag==1">【可兑换商品】</div>
                                        <div class="goodsnums"><FahuoNums :item='item'/></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bottomcon">
                            <div class="bottomcon-orderbtn" @click="goFhOrder">
                                <div class="bottomcon-orderbtn-words">下一步</div>
                            </div>
                        </div> 
                    </div>
             </div>
             <div class="tabcon" v-if="active==1">
                <div class="maincon" v-if="hasfahuo===0">
                    <van-empty description="您还没有发货记录哦" />
                </div>
                <div class="maincon" v-if="hasfahuo>0">
                   <FahuoItem 
                   v-for="item in fahuolist"
                   :key="item.id"
                   :orderinfo="item"
                   :ordergoods="item.ordergoods"
                  />
                </div> 
            </div>
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import FahuoItem from '@/components/fahuoitem'
import { Tab, Tabs,Empty } from 'vant';
import FahuoNums from "@/components/fahuonums"

export default {
  name: 'fahuo',
  data(){
      return{
         active:0, 
         goodslist:[],
         hasstock:'',
         fahuolist:[],
         hasfahuo:''    
      }
  },
  computed:{
      fahuototal(){
         return this.$store.getters.totalfahuonums(this.$store.state.fahuo.clicked)
      }
  },  
  created(){
    this.$store.commit('INIT_FAHUO')
    this.$store.commit('INIT_ADDRESS')
    this.getList()
  },
  methods:{
    getList(){
        this.$post("/fahuo/getSelfFahuolist",{}).then((data)=>{
                if(data.result.success){
                    this.goodslist=data.result.info.list
                    this.hasstock=data.result.info.nums
                }else{
                    this.$toast(data.result.info)
                }
         })
    },   
    goFhOrder(){
        if(this.fahuototal<=0){
            this.$toast("请选择发货商品数量")
            return false
        }
        this.$go("/fhorder");
    },
    switchTab(tabIndex){
        if(tabIndex==0){ 
            this.getList()
        }else if(tabIndex==1){
            this.$post("/fahuo/getFahuoHistory",{}).then((data)=>{
                if(data.result.success){
                    this.fahuolist=data.result.info.list
                    this.hasfahuo=data.result.info.nums
                }else{
                    this.$toast(data.result.info)
                }
           })
        }
    } 
  },
  components:{
      NavTop,FahuoItem,FahuoNums,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Empty.name]:Empty 
  }
}
</script>
<style scoped>
#fahuo{background-color:#F6F6F6;min-height: 100vh;}
.maincon{display: flex;flex-flow: column nowrap;margin-bottom: 100px;padding: 0 0.25rem;}
.goodsitem{display: flex;padding: 0.25rem;background-color: #fff;margin-top: 0.25rem;height: 3.8rem;align-items:center;border:1px solid #e7e7e7;border-radius: 0.15rem;}
.goodsitem-row{display: flex;flex-flow: row nowrap;justify-content: flex-start;width:100%;}
.goodsitem-col1 img{width:2rem;}
.goodsitem-col2 {margin-left: 0.25rem;display: flex; flex-flow: column nowrap;text-align: left;width:100%;}
.goodsitem-col2-line1{font-size: 0.35rem;}
.goodsitem-col2-line2{font-size: 0.35rem;color:#5e5e5e;margin-top: 0.15rem;}
.goodsitem-col2-line3{margin-top: 0.2rem;display: flex;flex-flow: row nowrap;}
.goodsnums{margin-left: auto;}
.goodsprice{color:#ff3600;font-size:0.4rem;display: flex;align-items: center;}
.bottomcon{display: flex;width:100%;height: 46px;position: fixed;left:0;bottom: 50px;align-items: center;justify-content: center;}
.bottomcon-left{display: flex;padding-left: 0.5rem;}
.goodswords{color:#333;font-size:0.35rem}
.bottomcon-right{margin-left: auto;padding-right: 0.3rem;}
.bottomcon-orderbtn{background-color:#ee0a24;color:#fff;height:46px;width:100%;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;}
.bottomcon-orderbtn-words{font-size:0.35rem;}
::v-deep .fixcon{margin-bottom: 0!important;}
::v-deep .van-tabs{height:44px;}
::v-deep .van-tabs--line .van-tabs__wrap{position: fixed;width:100%;height: 44px;}
</style>


